import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import { Col, Container, Row, Button, Spinner, OverlayTrigger, Popover } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import ChemEdit from '../ChemEdit';
import QueryTable from '../QueryTable';
import HashLink from '../HashLink';
import Tabs from '../Tabs';
import { PencilSquare, PlusSquare } from 'react-bootstrap-icons';
import { withSafetyDefaultRoute } from './withSafetyDefaultRoute';

class Safety extends ChemComponent {
	constructor(props) {
		super(props);

		this.state = {
			chemList: this.copyTable(chemList),
			search: {
				CHEM_NAME: '',
				STORAGE_NAME: '',
				H_STATEMENT_ID: [],
				H_STATEMENT: '',
				P_STATEMENT_ID: [],
				P_STATEMENT: '',
				SIGNAL_ID: null,
				AGGIH: null,
				EPA: null,
				IARC: null,
				NIOSH: null,
				NTP: null,
				OSHA: false,
				CAL_OSHA: false,
				CARCI_65: false,
				PICT_ID: [],
				PH_INFO: '',
				RTECS_FLAG: false,
				MDL_NUM: false,
				PUBCHEM: false,
				HARMONIZED_SYS: '',
				PUBCHEM_CID: false,
				RMP1: false,
				RMP3: false,
				RMP4: false,
				RMP2: false,
				TPQ: false,
				TPQ2: false,
				TRI_C: null,
				TRI_REPORT_THRESHOLD: null,
				DEV_65: [],
				REPRO_M: '',
				REPRO_F: '',
				ACUTE_H_FLAG: false,
				EXTREM_H_FLAG: false,
				HAP: false,
				CAA_URBAN_AIR: false,
				ANIMAL_TUMOR: false,
				SCHEDULE: [],
				CONT_SUBS_FLAG: [],
				FED_PRECURS_FLAG: [],
				CAL_PRECURS_FLAG: false,
				LACHRYMATOR: false,
				SKIN_ABSORB: false,
				VESICANT: false,
				UNPLEASANT_ODOR: false,
				STENCH: false,
				RUBEFACIANT: false,
				PHOTOSENSITIZER: false,
				ENDOCRINE_DIS: false,
				organ_id_input: {},
				ORGAN_ID: [],
				ORGAN_FLAG: false,
				NFPA_STATEMENT: false,
				HEALTH_NFPA_ID: [],
				FLAM_NFPA_ID: [],
				INSTA_NFPA_ID: [],
				SPEC_NFPA_ID: [],
				NFPA_STATEMENT_ID: [],
				HMIS_STATEMENT: false,
				HEALTH_HMIS_ID: [],
				FLAM_HMIS_ID: [],
				PHYS_HMIS_ID: [],
				CHRON_HMIS_ID: [],
				HMIS_STATEMENT_ID: [],
				TOXIC_FLAG: false,
				TOXIC_INFO: '',
				USAGE_MISC_FLAG: false,
				USAGE_MISC_INFO: '',
				STABILITY_REACT_FLAG: false,
				STAB_REACT: '',
				WATER_REACTIVE: false,
				EXPLOS_PEROXIDES: false,
				PSN: '',
				DIVISION: false,
				PACKING_GROUP: false,
				RQ: false,
				MARINE_POL: false,
				DOT_PIH: null,
				DOT_UN: false,
				CERCLA: false,
				MARINE_POL_PP: false,
				ERG_GUIDE: false,
				EPCRA: false,
				I_STANDARD: false,
				TRGS: false,
			},
			showSearch: true,
			searchCount: 0,
			renderKey: 0
		};
	}
	
	onChangeSearch(accessor, value) {
		var search = this.copyObject(this.state.search);
		this.setByAccessor(search, accessor, value);
		this.mergeState({ search: search });
	}
	
	onExpandSearch(event) {
		this.mergeState({
			showSearch: true,
			chemList: this.copyTable(chemList),
			renderKey: this.state.renderKey + 1
		});
		if (event && event.nativeEvent && event.nativeEvent.submitter) event.nativeEvent.submitter.blur();		
	}
	
	prepareSearch() {
		var search = this.copyObject(this.state.search);
		this.js2mvc(search, [...carcinogenSearch, ...pictogramSearch, ...profileSearch, ...specialSearch,
			...organSearch, ...hazardSearch, ...toxicSearch, ...shippingSearch, ...istdSearch]);
		
		// look for 'Y' in H_STATEMENT_ID
		var hstmt_y_idx = search.H_STATEMENT_ID.indexOf('Y');
		// if it was found
		if (hstmt_y_idx >= 0) {
			// remove from the array
			search.H_STATEMENT_ID.splice(hstmt_y_idx, 1);
			
			// set H_STATEMENT to Y
			search.H_STATEMENT = 'Y'
		} else {
			// clear H_STATEMENT
			search.H_STATEMENT = '';
		}
		
		// same for P_STATEMENT_ID
		var pstmt_y_idx = search.P_STATEMENT_ID.indexOf('Y');
		if (pstmt_y_idx >= 0) {
			search.P_STATEMENT_ID.splice(pstmt_y_idx, 1);
			search.P_STATEMENT = 'Y'
		} else {
			search.P_STATEMENT = '';
		}
		
		// same for controlled substance/schedule flags, but we can replace the entire array
		if (search.SCHEDULE.includes('Y')) search.SCHEDULE = 'Y';
		if (search.CONT_SUBS_FLAG.includes('Y')) search.CONT_SUBS_FLAG = 'Y';
		if (search.FED_PRECURS_FLAG.includes('Y')) search.FED_PRECURS_FLAG = 'Y';
		
		// TRI_C will be a single code or 'Y' for 'Any'
		if (search.TRI_C === 'Y') {
			search.TRI_C = '';
			search.TRI_REPORT_THRESHOLD = 'Y';
		}
		
		// DEV_65 also contains REPRO_M, REPRO_F
		if (search.DEV_65.includes('M')) search.REPRO_M = 'Y';
		if (search.DEV_65.includes('F')) search.REPRO_F = 'Y';
		search.DEV_65 = search.DEV_65.includes('Y') ? 'Y' : '';

		// translate organ_id_input to ORGAN_ID array
		var organKeys = Object.keys(search.organ_id_input);
		var anyCheckboxSeen = false;
		for (var k = 0; k < organKeys.length; k++) {
			if (organKeys[k].startsWith('ORGAN_ID_')) {
				// get embedded value
				var embeddedValue = organKeys[k].substring(9);
				
				// if embedded value is Y and matches checkbox value
				if (embeddedValue === 'Y') {
					if (search.organ_id_input[organKeys[k]] === 'Y') {
						// clear ID array
						search.ORGAN_ID = [];
						search.ORGAN_FLAG = 'Y'
						
						// we are done
						break;
					} else {
						// use null value for ORGAN_FLAG
						search.ORGAN_FLAG = null;
					}
					anyCheckboxSeen = true;
				} else {
					// if embedded value matches checkbox value
					if (+embeddedValue === this.getNumeric(search.organ_id_input[organKeys[k]], -1)) {
						search.ORGAN_ID.push(+embeddedValue);
					}
				}
			}
		}
		// if the 'Any' checkbox was not present
		if (!anyCheckboxSeen) search.ORGAN_FLAG = null;
		
		// concat NFPA statement IDs
		search.NFPA_STATEMENT_ID = search.NFPA_STATEMENT === 'Y' ? [] :
			[...search.HEALTH_NFPA_ID, ...search.FLAM_NFPA_ID, ...search.INSTA_NFPA_ID, ...search.SPEC_NFPA_ID];
			
		// concat HMIS statement IDs
		search.HMIS_STATEMENT_ID = search.HMIS_STATEMENT === 'Y' ? [] :
			[...search.HEALTH_HMIS_ID, ...search.FLAM_HMIS_ID, ...search.PHYS_HMIS_ID, ...search.CHRON_HMIS_ID];
			
		return search;
	}		

	onSubmitSearch(event) {
		var newChemList = this.copyTable(chemList);		
		newChemList.ajax.data = { search: this.prepareSearch() };
		newChemList.hold = false;
		newChemList.columns = this.filterColumns(newChemList.columns, newChemList.ajax.data.search);
		this.mergeState({ 
			chemList: newChemList,
			showSearch: false,
			searchCount: null,
			renderKey: this.state.renderKey + 1
		});
		if (event && event.nativeEvent && event.nativeEvent.submitter) event.nativeEvent.submitter.blur();
	}
	
	filterColumns(columns, search) {
		var newColumns = [];
		var filters = [];
		
		// collect names of all columns that have data
		var keys = Object.keys(search);
		for (var k = 0; k < keys.length; k++) {
			if (!this.isEmpty(search[keys[k]])) {
				filters.push(keys[k]);
			}
		}
		
		for (var c = 0; c < columns.length; c++) {
			if (!columns[c].includedby ||
				(Array.isArray(columns[c].includedby) && columns[c].includedby.some(f => filters.includes(f))) ||
				(columns[c].includedby && filters.includes(columns[c].includedby))) {
				// make a copy of the column
				var newColumn = this.copyColumn(columns[c]);
				
				// add to new list of columns
				newColumns.push(newColumn);
			}
		}

		return newColumns;
	}

	addChemical() {
		this.props.navigate('/Reuse/Chemicals/new');
	}
	
	editChemical(chemId) {
		this.props.setChemicalEditable(true);
		this.props.navigate('/Reuse/Chemicals/' + chemId);
	}

	viewChemical(chemId) {
		this.props.setChemicalEditable(false);
		this.props.navigate('/Reuse/Chemicals/' + chemId);
	}
	
	convertTabToURL(tab) {
		if (tab === 'Special\\r\\nConsiderations') tab = 'Special_Considerations'
		return tab;
	}
	
	convertURLToTab(url) {
		if (url === 'Special_Considerations') url = 'Special\\r\\nConsiderations'
		return url;
	}

	onClickTabItem(tab) {
		this.props.navigate('/Reuse/Safety/' + this.convertTabToURL(tab));
	}
	
	onSearchResult(data) {
		this.mergeState({
			searchCount: data.ResultCount
		});
	}

	render() {
		
		var exportSearch = this.prepareSearch();
		var exportColumns = this.convertWidthsToExcel(this.filterColumns(chemList.columns, exportSearch));
		exportColumns.splice(this.findColumnByAccessor('id'), 1);

		var exportData = this.createHiddenFormData({
			__RequestVerificationToken: this.props.user.antiForgeryToken,
			Action: 'Safety',
			columns: exportColumns,
			search: exportSearch
		});
		
		return (<>
			<Container fluid>
			  <Row>
			    <Col style={{ paddingTop: '20px', marginBottom: '20px', border: '1px solid #ccc', borderRadius: 6, backgroundColor: '#FEFEFE' }}>
				  <Container fluid>	
					<Row>
					  <Col xs={12}>
						<div style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '10px' }}>Chemical Safety Search</div>
						{this.state.showSearch && <Tabs activeTab={this.convertURLToTab(this.state.activeTab)}
							onClickTabItem={(tab) => this.onClickTabItem(tab)}>
						  <div label='Profile'>
						    <Container fluid>
							  <Row>
							    <Col style={{ borderBottom: '1px solid #eee' }}>
								  <ChemEdit parent={this} user={this.props.user} columns={nameSearch} data={this.state.search}
									renderKey={this.state.renderKey} onChange={(accessor, value) => this.onChangeSearch(accessor, value)} />
								</Col>
							  </Row>
							  <Row>
								<Col>
								  <div style={{ fontSize: '18px', fontWeight: 'bold', marginTop: '10px', marginBottom: '10px' }}>Carcinogen</div>
								</Col>
							  </Row>
							  <Row>
							    <Col style={{ borderBottom: '1px solid #eee' }}>
								  <ChemEdit parent={this} user={this.props.user} columns={carcinogenSearch} data={this.state.search}
									renderKey={this.state.renderKey} onChange={(accessor, value) => this.onChangeSearch(accessor, value)} />
								</Col>
							  </Row>
							  <Row>
							    <Col xs={4} style={{ borderBottom: '1px solid #eee' }}>
								  <div style={{ fontSize: '18px', fontWeight: 'bold', marginTop: '10px', marginBottom: '10px' }}>Hazard Pictogram</div>
								  <ChemEdit parent={this} user={this.props.user} columns={pictogramSearch} data={this.state.search}
									renderKey={this.state.renderKey} onChange={(accessor, value) => this.onChangeSearch(accessor, value)}
									labelColWidth={0} valueColWidth={12} />
								</Col>
							    <Col xs={8} style={{ borderBottom: '1px solid #eee' }}>
								  <div style={{ fontSize: '18px', fontWeight: 'bold', marginTop: '10px', marginBottom: '10px' }}>Profile</div>
								  <ChemEdit parent={this} user={this.props.user} columns={profileSearch} data={this.state.search}
									renderKey={this.state.renderKey} onChange={(accessor, value) => this.onChangeSearch(accessor, value)} />
								</Col>
							  </Row>
							</Container>
						  </div>
						  <div label='Special\r\nConsiderations'>
						    <Container fluid>
							  <Row>
								<Col>
								  <div style={{ fontSize: '12px', fontWeight: 'bold', marginTop: '10px', marginBottom: '10px' }}>RMP Requirements</div>
								</Col>
							  </Row>
							  <Row>
							    <Col style={{ borderBottom: '1px solid #eee' }}>
								  <ChemEdit parent={this} user={this.props.user} columns={specialSearch} data={this.state.search}
									renderKey={this.state.renderKey} onChange={(accessor, value) => this.onChangeSearch(accessor, value)} />
								</Col>
							  </Row>
							  <Row>
								<Col>
								  <div style={{ fontSize: '14px', fontWeight: 'bold', marginTop: '10px', marginBottom: '10px' }}>Target Organs</div>
								</Col>
							  </Row>
							  <Row>
							    <Col style={{ borderBottom: '1px solid #eee' }}>
								  <ChemEdit parent={this} user={this.props.user} columns={organSearch} data={this.state.search}
									renderKey={this.state.renderKey} onChange={(accessor, value) => this.onChangeSearch(accessor, value)} />
								</Col>
							  </Row>
							</Container>
						  </div>
						  <div label='Additional'>
							<Container fluid>
							  <Row>
								<Col>
								  <div style={{ fontSize: '14px', fontWeight: 'bold', marginTop: '10px', marginBottom: '10px' }}>Hazards</div>
								</Col>
							  </Row>
							  <Row>
							    <Col style={{ borderBottom: '1px solid #eee' }}>
								  <ChemEdit parent={this} user={this.props.user} columns={hazardSearch} data={this.state.search}
									renderKey={this.state.renderKey} onChange={(accessor, value) => this.onChangeSearch(accessor, value)} />
								</Col>
							  </Row>
							  <Row>
							    <Col style={{ borderBottom: '1px solid #eee' }}>
								  <ChemEdit parent={this} user={this.props.user} columns={toxicSearch} data={this.state.search}
									renderKey={this.state.renderKey} onChange={(accessor, value) => this.onChangeSearch(accessor, value)} />
								</Col>
							  </Row>
							  <Row>
								<Col>
								  <div style={{ fontSize: '14px', fontWeight: 'bold', marginTop: '10px', marginBottom: '10px' }}>Shipping Information</div>
								</Col>
							  </Row>
							  <Row>
							    <Col style={{ borderBottom: '1px solid #eee' }}>
								  <ChemEdit parent={this} user={this.props.user} columns={shippingSearch} data={this.state.search}
									renderKey={this.state.renderKey} onChange={(accessor, value) => this.onChangeSearch(accessor, value)} />
								</Col>
							  </Row>
							  <Row>
								<Col>
								  <div style={{ fontSize: '14px', fontWeight: 'bold', marginTop: '10px', marginBottom: '10px' }}>Other Information</div>
								</Col>
							  </Row>
							  <Row>
							    <Col style={{ borderBottom: '1px solid #eee' }}>
								  <ChemEdit parent={this} user={this.props.user} columns={istdSearch} data={this.state.search}
									renderKey={this.state.renderKey} onChange={(accessor, value) => this.onChangeSearch(accessor, value)} />
								</Col>
							  </Row>
							</Container>
						  </div>
						</Tabs>}
					  </Col>
					</Row>
					<Form.Group as={Row} style={{ borderTop: '1px solid #eee', paddingTop: 10, marginBottom: 10 }}>
					  <Col xs={3} style={{ marginTop: 8}}>
						{this.isEmpty(this.state.searchCount) ? <Spinner animation='border' as='div' size='sm' style={{ marginRight: '4px' }} /> : this.state.searchCount} records found.
					  </Col>
					  <Col xs={1} style={{ marginTop: 6}}>
						<form action={this.getConfig().host + '/Reuse/Excel'} method='POST'>
							{exportData.map((excelFormField, index) => {
								return (<input key={index} type='hidden' name={excelFormField.name} value={excelFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to Excel</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Excel.png'} style={{ paddingLeft: '20px' }} alt="Export to Excel" />
							</OverlayTrigger>
						</form>
					  </Col>
					  <Col xs={1} style={{ marginTop: 6}}>
						<form action={this.getConfig().host + '/Reuse/Pdf'} method='POST'>
							{exportData.map((pdfFormField, index) => {
								return (<input key={index} type='hidden' name={pdfFormField.name} value={pdfFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to PDF</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Pdf.png'} style={{ paddingLeft: '20px' }} alt="Export to PDF" />
							</OverlayTrigger>
						</form>
					  </Col>
					  <Col xs={7}>
						{this.state.showSearch ?
							<Button id="update" variant="warning" type="button" className="float-end" onClick={(event) => this.onSubmitSearch(event)}>Search</Button> :
							<Button id="expand" variant="warning" type="button" className="float-end" onClick={(event) => this.onExpandSearch(event)}>Modify Search</Button>
						}
					  </Col>
					</Form.Group>
				  </Container>
				</Col>
			  </Row>
			  <Row>
				<Col>
				  <QueryTable renderKey={this.state.renderKey} parent={this} name='Reuse_Chemicals' table={this.state.chemList}
				    onResult={(data) => this.onSearchResult(data)} offsetHeight='150px' />
				</Col>
			  </Row>
			</Container>
		</>);		
	}
}

const nameSearch = [
	{ Header: 'Name like', accessor: 'CHEM_NAME', row: 0, col: 0, subscript: '(use % for wild card)' },
	{ Header: 'Storage', accessor: 'STORAGE_NAME', type: 'select', row: 0, col: 1,
		options: { value: 'TEMP_NAME', label: 'TEMP_NAME', entity: 'REUSE.STORAGE_TEMP' }},
	{ Header: 'Hazard Statements', accessor: 'H_STATEMENT_ID', type: 'list', row: 1, col: 0,
		options: { value: 'STATEMENT_ID', label: 'STATEMENT_CODE', entity: 'REUSE.H_STMT_SELECT_VW', order: 'STATEMENT_CODE' }},
	{ Header: 'Precautionary Statements', accessor: 'P_STATEMENT_ID', type: 'list', row: 1, col: 1,
		options: { value: 'STATEMENT_ID', label: 'STATEMENT_CODE', entity: 'REUSE.P_STMT_SELECT_VW', order: 'STATEMENT_CODE' }},
	{ Header: 'Signal Word', accessor: 'SIGNAL_ID', type: 'select', row: 1, col: 2,
		options: { value: 'SIGNAL_ID', label: 'SIGNAL_NAME', entity: 'REUSE.SIGNAL_WORD', order: 'SIGNAL_ID',
			search: { Attribute: 'DELETE_FLAG', Operator: 'is null' }}},
];

const carcinogenSearch = [
	{ Header: 'ACGIH', accessor: 'AGGIH', type: 'select', row: 0, col: 0,
		options: { value: 'STATEMENT_ID', label: 'STATEMENT_CODE', entity: 'REUSE.CHEM_SAFETY_STATEMENT', order: 'STATEMENT_CODE',
			search: { Operator: 'and', Children: [
				{ Attribute: 'TYPE_CODE', Operator: '=', LongValue: 80 },
				{ Attribute: 'DELETE_FLAG', Operator: 'is null' }
	]}}},
	{ Header: 'EPA', accessor: 'EPA', type: 'select', row: 0, col: 1,
		options: { value: 'STATEMENT_ID', label: 'STATEMENT_CODE', entity: 'REUSE.CHEM_SAFETY_STATEMENT', order: 'STATEMENT_CODE',
			search: { Operator: 'and', Children: [
				{ Attribute: 'TYPE_CODE', Operator: '=', LongValue: 81 },
				{ Attribute: 'DELETE_FLAG', Operator: 'is null' }
	]}}},
	{ Header: 'IARC', accessor: 'IARC', type: 'select', row: 0, col: 2,
		options: { value: 'STATEMENT_ID', label: 'STATEMENT_CODE', entity: 'REUSE.CHEM_SAFETY_STATEMENT', order: 'STATEMENT_CODE',
			search: { Operator: 'and', Children: [
				{ Attribute: 'TYPE_CODE', Operator: '=', LongValue: 82 },
				{ Attribute: 'DELETE_FLAG', Operator: 'is null' }
	]}}},
	{ Header: 'NIOSH', accessor: 'NIOSH', type: 'select', row: 1, col: 0,
		options: { value: 'STATEMENT_ID', label: 'STATEMENT_CODE', entity: 'REUSE.CHEM_SAFETY_STATEMENT', order: 'STATEMENT_CODE',
			search: { Operator: 'and', Children: [
				{ Attribute: 'TYPE_CODE', Operator: '=', LongValue: 83 },
				{ Attribute: 'DELETE_FLAG', Operator: 'is null' }
	]}}},
	{ Header: 'NTP', accessor: 'NTP', type: 'select', row: 1, col: 1,
		options: { value: 'STATEMENT_ID', label: 'STATEMENT_CODE', entity: 'REUSE.CHEM_SAFETY_STATEMENT', order: 'STATEMENT_CODE',
			search: { Operator: 'and', Children: [
				{ Attribute: 'TYPE_CODE', Operator: '=', LongValue: 84 },
				{ Attribute: 'DELETE_FLAG', Operator: 'is null' }
	]}}},
	{ Header: 'OSHA Listed', accessor: 'OSHA', type: 'checkbox', row: 2, col: 0 },
	{ Header: 'Cal OSHA Listed', accessor: 'CAL_OSHA', type: 'checkbox', row: 2, col: 1 },
	{ Header: 'Prop 65 Carcinogen', accessor: 'CARCI_65', type: 'checkbox', row: 2, col: 2 }
];

const pictogramSearch = [
	{ Header: '', accessor: 'PICT_ID', type: 'checklist', row: 0, col: 0,
		options: { value: 'PICT_ID', label: 'PICT_NAME', entity: 'REUSE.HAZARD_PICT', 
			search: { Operator: 'and', Children: [
				{ Attribute: 'TYPE_CODE', Operator: '=', LongValue: 1 },
				{ Attribute: 'DELETE_FLAG', Operator: 'is null' }
	]}}}
];

const profileSearch = [
	{ Header: 'pH', accessor: 'PH_INFO', row: 0, col: 0 },
	{ Header: 'RTECS Number', accessor: 'RTECS_FLAG', type: 'checkbox', row: 0, col: 1 },
	{ Header: 'MDL Number', accessor: 'MDL_NUM', type: 'checkbox', row: 1, col: 0 },
	{ Header: 'PubChem URL', accessor: 'PUBCHEM', type: 'checkbox', row: 1, col: 1 },
	{ Header: 'Harmonized System', accessor: 'HARMONIZED_SYS', row: 2, col: 0 },
	{ Header: 'PubChem Number', accessor: 'PUBCHEM_CID', type: 'checkbox', row: 2, col: 1 }
];

const specialSearch = [
	// column 1 
	{ Header: 'CAA 112(r) TQ', accessor: 'RMP1', type: 'checkbox', row: 0, col: 0, colwidth: 4 },
	{ Header: 'CalARP TQ', accessor: 'RMP3', type: 'checkbox', row: 1, col: 0, colwidth: 4 },
	{ Header: 'Non-molten TQ', accessor: 'RMP4', type: 'checkbox', row: 2, col: 0, colwidth: 4 },
	{ Header: 'OSHA highly hazardous TQ', accessor: 'RMP2', type: 'checkbox', row: 3, col: 0, colwidth: 4 },
	{ Header: 'TPQ §302', accessor: 'TPQ', type: 'checkbox', row: 4, col: 0, colwidth: 4 },
	{ Header: 'TPQ §302<br /><span style="font-size: 12px;">if not in molten form or in solution, and not a fine powder (<100 μm dia.)</span>',
		accessor: 'TPQ2', type: 'checkbox', row: 5, col: 0, colwidth: 4 },
	{ Header: 'Toxic Release Inventory', accessor: 'TRI_C', type: 'select', row: 6, col: 0, colwidth: 4,
		options: { value: 'CODE_ID', label: 'CODE_NAME', entity: 'REUSE.TRI_CODE_SELECT_VW', order: ['ANY_FIRST','CODE_NAME'] }},
	// column 2
	{ Header: 'Prop 65 Dev. Toxin', accessor: 'DEV_65', type: 'checklist', row: 0, col: 1, colwidth: 4, orient: 'horizontal',
		options: [{ value: 'Y', label: '(' },{ value: 'M', label: 'M' },{ value: 'F', label: 'F)' }]},
	{ Header: 'Acutely Hazardous', accessor: 'ACUTE_H_FLAG', type: 'checkbox', row: 1, col: 1, colwidth: 4 },
	{ Header: 'CA Extremely Hazardous', accessor: 'EXTREM_H_FLAG', type: 'checkbox', row: 2, col: 1, colwidth: 4 },
	{ Header: 'Hazardous Air Pollutant', accessor: 'HAP', type: 'checkbox', row: 3, col: 1, colwidth: 4 },
	{ Header: 'CAA Urban Air Toxics Strategy Pollutant', accessor: 'CAA_URBAN_AIR', type: 'checkbox', row: 4, col: 1, colwidth: 4 },
	{ Header: 'Significant Tumor Incidence in Animals', accessor: 'ANIMAL_TUMOR', type: 'checkbox', row: 5, col: 1, colwidth: 4 },
	{ Header: 'CWC Schedule', accessor: 'SCHEDULE', type: 'checklist', row: 6, col: 1, colwidth: 4,
		options: [{ value: '1A', label: '1A' },{ value: '1B', label: '1B' },
			{ value: '2A', label: '2A' },{ value: '2B', label: '2B' },
			{ value: '3A', label: '3A' },{ value: '3B', label: '3B' },
			{ value: 'Y', label: 'Any' }], orient: 'horizontal' },
	// column 3
	{ Header: 'Controlled Substance Schedule', accessor: 'CONT_SUBS_FLAG', type: 'checklist', orient: 'horizontal', row: 0, col: 2, colwidth: 4, 
		options: [{ value: 'I', label: 'I' },{ value: 'II', label: 'II' },{ value: 'III', label: 'III' },
			{ value: 'IV', label: 'IV' },{ value: 'V', label: 'V' },{ value: 'Y', label: 'Any' }]},
	{ Header: 'Federal Precursor Chemical List', accessor: 'FED_PRECURS_FLAG', type: 'checklist', row: 1, col: 2, colwidth: 4, 
		options: [{ value: 'I', label: 'I' },{ value: 'II', label: 'II' },{ value: 'Y', label: 'Any' }], orient: 'horizontal' },
	{ Header: 'Cal DOJ Precursor Chemical', accessor: 'CAL_PRECURS_FLAG', type: 'checkbox', row: 2, col: 2, colwidth: 4 },
	{ Header: 'Lachrymator', accessor: 'LACHRYMATOR', type: 'checkbox', row: 3, col: 2, colwidth: 2 },
	{ Header: 'Readily Absorbed through Skin', accessor: 'SKIN_ABSORB', type: 'checkbox', row: 4, col: 2, colwidth: 2 },
	{ Header: 'Vesicant', accessor: 'VESICANT', type: 'checkbox', row: 5, col: 2, colwidth: 2 },
	{ Header: 'Unpleasant Odor', accessor: 'UNPLEASANT_ODOR', type: 'checkbox', row: 6, col: 2, colwidth: 2 },
	// column 4
	{ Header: 'Stench', accessor: 'STENCH', type: 'checkbox', row: 3, col: 3, colwidth: 2 },
	{ Header: 'Rubefacient', accessor: 'RUBEFACIANT', type: 'checkbox', row: 4, col: 3, colwidth: 2 },
	{ Header: 'Photosensitizer', accessor: 'PHOTOSENSITIZER', type: 'checkbox', row: 5, col: 3, colwidth: 2 },
	{ Header: 'Endocrine Disruptor', accessor: 'ENDOCRINE_DIS', type: 'checkbox', row: 6, col: 3, colwidth: 2 },
];

const organSearch = [
	{ value: 'Y', Header: 'Any', accessor: 'organ_id_input.ORGAN_ID_Y', type: 'checkbox', row: 0, col: 0 },
	{ value: '35', Header: 'Adrenal Glands', accessor: 'organ_id_input.ORGAN_ID_35', type: 'checkbox', row:1, col: 0 },  
	{ value: '1', Header: 'Bladder', accessor: 'organ_id_input.ORGAN_ID_1', type: 'checkbox', row: 2, col: 0 },  
	{ value: '2', Header: 'Blood', accessor: 'organ_id_input.ORGAN_ID_2', type: 'checkbox', row: 3, col: 0 },  
	{ value: '20', Header: 'Bone Marrow', accessor: 'organ_id_input.ORGAN_ID_20', type: 'checkbox', row: 4, col: 0 },  
	{ value: '16', Header: 'Bones', accessor: 'organ_id_input.ORGAN_ID_16', type: 'checkbox', row: 5, col: 0 },  
	{ value: '3', Header: 'Brain', accessor: 'organ_id_input.ORGAN_ID_3', type: 'checkbox', row: 6, col: 0 },  
	{ value: '5', Header: 'CNS', accessor: 'organ_id_input.ORGAN_ID_5', type: 'checkbox', row: 7, col: 0 },  
	{ value: '4', Header: 'Cardiovascular', accessor: 'organ_id_input.ORGAN_ID_4', type: 'checkbox', row: 8, col: 0 },  
	{ value: '28', Header: 'Ears', accessor: 'organ_id_input.ORGAN_ID_28', type: 'checkbox', row: 9, col: 0 },  
	{ value: '6', Header: 'Eyes', accessor: 'organ_id_input.ORGAN_ID_6', type: 'checkbox', row: 10, col: 0 },  
	{ value: '25', Header: 'GI tract', accessor: 'organ_id_input.ORGAN_ID_25', type: 'checkbox', row: 11, col: 0 },
	{ value: '7', Header: 'Heart', accessor: 'organ_id_input.ORGAN_ID_7', type: 'checkbox', row: 0, col: 1 },
	{ value: '34', Header: 'Immune System', accessor: 'organ_id_input.ORGAN_ID_34', type: 'checkbox', row: 1, col: 1 },  
	{ value: '8', Header: 'Kidneys', accessor: 'organ_id_input.ORGAN_ID_8', type: 'checkbox', row: 2, col: 1 },  
	{ value: '9', Header: 'Liver', accessor: 'organ_id_input.ORGAN_ID_9', type: 'checkbox', row: 3, col: 1 },  
	{ value: '10', Header: 'Lungs', accessor: 'organ_id_input.ORGAN_ID_10', type: 'checkbox', row: 4, col: 1 },  
	{ value: '24', Header: 'Lymphatic system', accessor: 'organ_id_input.ORGAN_ID_24', type: 'checkbox', row: 5, col: 1 },  
	{ value: '26', Header: 'Mucous Membranes', accessor: 'organ_id_input.ORGAN_ID_26', type: 'checkbox', row: 6, col: 1 },  
	{ value: '11', Header: 'Nerves', accessor: 'organ_id_input.ORGAN_ID_11', type: 'checkbox', row: 7, col: 1 },  
	{ value: '32', Header: 'Nose / Olfactory', accessor: 'organ_id_input.ORGAN_ID_32', type: 'checkbox', row: 8, col: 1 },  
	{ value: '31', Header: 'PNS', accessor: 'organ_id_input.ORGAN_ID_31', type: 'checkbox', row: 9, col: 1 },  
	{ value: '12', Header: 'Pancreas', accessor: 'organ_id_input.ORGAN_ID_12', type: 'checkbox', row: 10, col: 1 },  
	{ value: '33', Header: 'Reproductive', accessor: 'organ_id_input.ORGAN_ID_33', type: 'checkbox', row: 11, col: 1 },
	{ value: '22', Header: 'Reproductive (female)', accessor: 'organ_id_input.ORGAN_ID_22', type: 'checkbox', row: 0, col: 2 },
	{ value: '23', Header: 'Reproductive (male)', accessor: 'organ_id_input.ORGAN_ID_23', type: 'checkbox', row: 1, col: 2 },  
	{ value: '27', Header: 'Respiratory System', accessor: 'organ_id_input.ORGAN_ID_27', type: 'checkbox', row: 2, col: 2 },  
	{ value: '30', Header: 'Skeletal Muscle', accessor: 'organ_id_input.ORGAN_ID_30', type: 'checkbox', row: 3, col: 2 },  
	{ value: '13', Header: 'Skin', accessor: 'organ_id_input.ORGAN_ID_13', type: 'checkbox', row: 4, col: 2 },  
	{ value: '17', Header: 'Smooth Muscle', accessor: 'organ_id_input.ORGAN_ID_17', type: 'checkbox', row: 5, col: 2 },  
	{ value: '19', Header: 'Spleen', accessor: 'organ_id_input.ORGAN_ID_19', type: 'checkbox', row: 6, col: 2 },  
	{ value: '18', Header: 'Teeth', accessor: 'organ_id_input.ORGAN_ID_18', type: 'checkbox', row: 7, col: 2 },  
	{ value: '14', Header: 'Testes', accessor: 'organ_id_input.ORGAN_ID_14', type: 'checkbox', row: 8, col: 2 },  
	{ value: '21', Header: 'Thymus', accessor: 'organ_id_input.ORGAN_ID_21', type: 'checkbox', row: 9, col: 2 },  
	{ value: '15', Header: 'Thyroid', accessor: 'organ_id_input.ORGAN_ID_15', type: 'checkbox', row: 10, col: 2 },  
	{ value: '29', Header: 'Vascular System', accessor: 'organ_id_input.ORGAN_ID_29', type: 'checkbox', row: 11, col: 2 }
];

const hazardSearch = [
	{ Header: 'Any NFPA Hazard', accessor: 'NFPA_STATEMENT', type: 'checkbox', row: 0, col: 0 },
	{ Header: 'Health', accessor: 'HEALTH_NFPA_ID', type: 'checklist', row: 1, col: 0,
		options: [{ value: 357, label: '0' },{ value: 356, label: '1' },
			{ value: 355, label: '2' },{ value: 354, label: '3' },
			{ value: 353, label: '4' }], orient: 'horizontal' },
	{ Header: 'Flammability', accessor: 'FLAM_NFPA_ID', type: 'checklist', row: 2, col: 0,
		options: [{ value: 362, label: '0' },{ value: 361, label: '1' },
			{ value: 360, label: '2' },{ value: 359, label: '3' },
			{ value: 358, label: '4' }], orient: 'horizontal' },
	{ Header: 'Instability', accessor: 'INSTA_NFPA_ID', type: 'checklist', row: 3, col: 0,
		options: [{ value: 373, label: '0' },{ value: 372, label: '1' },
			{ value: 371, label: '2' },{ value: 370, label: '3' },
			{ value: 369, label: '4' }], orient: 'horizontal' },
	{ Header: 'Special', accessor: 'SPEC_NFPA_ID', type: 'checklist', row: 4, col: 0,
		options: [{ value: 364, label: 'ACID' },{ value: 363, label: 'ALK' },
			{ value: 365, label: 'COR' },{ value: 366, label: 'OX' },
			{ value: 367, label: <>&nbsp;<del>W</del></> },{ value: 368, label: <>&nbsp;<del>W</del>OX</> }], orient: 'horizontal' },
	{ Header: 'Any HMIS Hazard', accessor: 'HMIS_STATEMENT', type: 'checkbox', row: 0, col: 1 },
	{ Header: 'Health', accessor: 'HEALTH_HMIS_ID', type: 'checklist', row: 1, col: 1,
		options: [{ value: 375, label: '0' },{ value: 376, label: '1' },
			{ value: 377, label: '2' },{ value: 378, label: '3' },
			{ value: 379, label: '4' }], orient: 'horizontal' },
	{ Header: 'Flammability', accessor: 'FLAM_HMIS_ID', type: 'checklist', row: 2, col: 1,
		options: [{ value: 380, label: '0' },{ value: 381, label: '1' },
			{ value: 382, label: '2' },{ value: 383, label: '3' },
			{ value: 384, label: '4' }], orient: 'horizontal' },
	{ Header: 'Physical', accessor: 'PHYS_HMIS_ID', type: 'checklist', row: 3, col: 1,
		options: [{ value: 385, label: '0' },{ value: 386, label: '1' },
			{ value: 387, label: '2' },{ value: 388, label: '3' },
			{ value: 389, label: '4' }], orient: 'horizontal' },
	{ Header: 'Chronic Health', accessor: 'CHRON_HMIS_ID', type: 'checklist', row: 4, col: 1,
		options: [{ value: 374, label: '*' }], orient: 'horizontal' },
];

const toxicSearch = [
	{ Header: 'Toxic Information', accessor: 'TOXIC_FLAG', type: 'checkbox', row: 0, col: 0, labelColWidth: 10, valueColWidth: 2 },
	{ Header: 'Contains', accessor: 'TOXIC_INFO', row: 0, col: 1 },
	{ Header: 'Usage/Misc Information', accessor: 'USAGE_MISC_FLAG', type: 'checkbox', row: 0, col: 2, labelColWidth: 10, valueColWidth: 2 },
	{ Header: 'Contains', accessor: 'USAGE_MISC_INFO', row: 0, col: 3 },
	{ Header: 'Stability/Reactivity', accessor: 'STABILITY_REACT_FLAG', type: 'checkbox', row: 0, col: 4, labelColWidth: 10, valueColWidth: 2 },
	{ Header: 'Contains', accessor: 'STAB_REACT', row: 0, col: 5 },
	{ Header: 'Water Reactive', accessor: 'WATER_REACTIVE', type: 'checkbox', row: 1, col: 4, labelColWidth: 10, valueColWidth: 2 },
	{ Header: 'May Form Explosive Peroxides', accessor: 'EXPLOS_PEROXIDES', type: 'checkbox', row: 1, col: 5, labelColWidth: 10, valueColWidth: 2 },
];

const shippingSearch = [
	{ Header: 'PSN', accessor: 'PSN', row: 0, col: 0 },
	{ Header: 'Division', accessor: 'DIVISION', type: 'checkbox', row: 0, col: 1, labelColWidth: 10, valueColWidth: 2 },
	{ Header: 'Packing Group', accessor: 'PACKING_GROUP', type: 'checkbox', row: 0, col: 2, labelColWidth: 10, valueColWidth: 2 },
	{ Header: 'RQ', accessor: 'RQ', type: 'checkbox', row: 0, col: 3, labelColWidth: 10, valueColWidth: 2 },
	{ Header: 'DOT Marine Pollutant (≥10%)', accessor: 'MARINE_POL', type: 'checkbox', row: 1, col: 0, labelColWidth: 10, valueColWidth: 2 },
	{ Header: 'DOT PIH', accessor: 'DOT_PIH', type: 'select', row: 1, col: 1,
		options: [{ value: null, label: 'Select...' },{ value: '0', label: 'None' },
			{ value: 'Y', label: 'Any' },{ value: '390', label: 'A' },
			{ value: '391', label: 'B' },{ value: '392', label: 'C' },
			{ value: '393', label: 'D' }]},
	{ Header: 'DOT UN #', accessor: 'DOT_UN', type: 'checkbox', row: 1, col: 2, labelColWidth: 10, valueColWidth: 2 },
	{ Header: 'CERCLA', accessor: 'CERCLA', type: 'checkbox', row: 1, col: 3, labelColWidth: 10, valueColWidth: 2 },
	{ Header: 'DOT Marine Pollutant - PP Severe (≥1%)', accessor: 'MARINE_POL_PP', type: 'checkbox', row: 2, col: 0, labelColWidth: 10, valueColWidth: 2 },
	{ Header: 'ERG Guide #', accessor: 'ERG_GUIDE', type: 'checkbox', row: 2, col: 2, labelColWidth: 10, valueColWidth: 2 },
	{ Header: 'EPCRA', accessor: 'EPCRA', type: 'checkbox', row: 2, col: 3, labelColWidth: 10, valueColWidth: 2 }
];

const istdSearch = [
	{ Header: 'International Standard', accessor: 'I_STANDARD', type: 'checkbox', row: 0, col: 0, labelColWidth: 10, valueColWidth: 2 },
	{ Header: 'TRGS 510 Storage Class', accessor: 'TRGS', type: 'checkbox', row: 0, col: 1, labelColWidth: 10, valueColWidth: 2 },
	{ Header: 'Health Hazard', accessor: 'HAZARD_ID_H', type: 'select', row: 1, col: 0,
		options: { value: 'HAZARD_ID', label: 'HAZARD_NAME', entity: 'REUSE.HAZARD_SELECT_VW', order: 'HAZARD_NAME',
			search: { Attribute: 'HAZARD_TYPE', Operator: '=', StringValue: 'H' }
	}},
	{ Header: 'Category', accessor: 'CAT_ID_H', type: 'select', row: 1, col: 1,
		options: { value: 'CAT_ID', label: 'CAT_NAME', entity: 'REUSE.HAZARD_CAT_SELECT_VW', order: 'CAT_NAME',
			search: { Operator: 'and', Children: [
				{ Attribute: 'HAZARD_ID', Operator: '=', LongAccessor: 'HAZARD_ID_H' },
				{ Attribute: 'HAZARD_TYPE', Operator: '=', StringValue: 'H' }
	]}}},
	{ Header: 'Health Hazard', accessor: 'HAZARD_ID_H2', type: 'select', row: 2, col: 0,
		options: { value: 'HAZARD_ID', label: 'HAZARD_NAME', entity: 'REUSE.HAZARD_SELECT_VW', order: 'HAZARD_NAME',
			search: { Attribute: 'HAZARD_TYPE', Operator: '=', StringValue: 'H' }
	}},
	{ Header: 'Category', accessor: 'CAT_ID_H2', type: 'select', row: 2, col: 1,
		options: { value: 'CAT_ID', label: 'CAT_NAME', entity: 'REUSE.HAZARD_CAT_SELECT_VW', order: 'CAT_NAME',
			search: { Operator: 'and', Children: [
				{ Attribute: 'HAZARD_ID', Operator: '=', LongAccessor: 'HAZARD_ID_H2' },
				{ Attribute: 'HAZARD_TYPE', Operator: '=', StringValue: 'H' }
	]}}},
	{ Header: 'Environmental Hazard', accessor: 'HAZARD_ID_E', type: 'select', row: 3, col: 0,
		options: { value: 'HAZARD_ID', label: 'HAZARD_NAME', entity: 'REUSE.HAZARD_SELECT_VW', order: 'HAZARD_NAME',
			search: { Attribute: 'HAZARD_TYPE', Operator: '=', StringValue: 'E' }
	}},
	{ Header: 'Category', accessor: 'CAT_ID_E', type: 'select', row: 3, col: 1,
		options: { value: 'CAT_ID', label: 'CAT_NAME', entity: 'REUSE.HAZARD_CAT_SELECT_VW', order: 'CAT_NAME',
			search: { Operator: 'and', Children: [
				{ Attribute: 'HAZARD_ID', Operator: '=', LongAccessor: 'HAZARD_ID_E' },
				{ Attribute: 'HAZARD_TYPE', Operator: '=', StringValue: 'E' }
	]}}},
	{ Header: 'Environmental Hazard', accessor: 'HAZARD_ID_E2', type: 'select', row: 4, col: 0,
		options: { value: 'HAZARD_ID', label: 'HAZARD_NAME', entity: 'REUSE.HAZARD_SELECT_VW', order: 'HAZARD_NAME',
			search: { Attribute: 'HAZARD_TYPE', Operator: '=', StringValue: 'E' }
	}},
	{ Header: 'Category', accessor: 'CAT_ID_E2', type: 'select', row: 4, col: 1,
		options: { value: 'CAT_ID', label: 'CAT_NAME', entity: 'REUSE.HAZARD_CAT_SELECT_VW', order: 'CAT_NAME',
			search: { Operator: 'and', Children: [
				{ Attribute: 'HAZARD_ID', Operator: '=', LongAccessor: 'HAZARD_ID_E2' },
				{ Attribute: 'HAZARD_TYPE', Operator: '=', StringValue: 'E' }
	]}}},
	{ Header: 'Physical Hazard', accessor: 'HAZARD_ID_P', type: 'select', row: 5, col: 0,
		options: { value: 'HAZARD_ID', label: 'HAZARD_NAME', entity: 'REUSE.HAZARD_SELECT_VW', order: 'HAZARD_NAME',
			search: { Attribute: 'HAZARD_TYPE', Operator: '=', StringValue: 'P' }
	}},
	{ Header: 'Category', accessor: 'CAT_ID_P', type: 'select', row: 5, col: 1,
		options: { value: 'CAT_ID', label: 'CAT_NAME', entity: 'REUSE.HAZARD_CAT_SELECT_VW', order: 'CAT_NAME',
			search: { Operator: 'and', Children: [
				{ Attribute: 'HAZARD_ID', Operator: '=', LongAccessor: 'HAZARD_ID_P' },
				{ Attribute: 'HAZARD_TYPE', Operator: '=', StringValue: 'P' }
	]}}},
	{ Header: 'Physical Hazard', accessor: 'HAZARD_ID_P2', type: 'select', row: 6, col: 0,
		options: { value: 'HAZARD_ID', label: 'HAZARD_NAME', entity: 'REUSE.HAZARD_SELECT_VW', order: 'HAZARD_NAME',
			search: { Attribute: 'HAZARD_TYPE', Operator: '=', StringValue: 'P' }
	}},
	{ Header: 'Category', accessor: 'CAT_ID_P2', type: 'select', row: 6, col: 1,
		options: { value: 'CAT_ID', label: 'CAT_NAME', entity: 'REUSE.HAZARD_CAT_SELECT_VW', order: 'CAT_NAME',
			search: { Operator: 'and', Children: [
				{ Attribute: 'HAZARD_ID', Operator: '=', LongAccessor: 'HAZARD_ID_P2' },
				{ Attribute: 'HAZARD_TYPE', Operator: '=', StringValue: 'P' }
	]}}},
];

const chemList = {
	ajax: { 
		url: '/Reuse/SafetySearch',
		data: null,
		accessor: 'Data'
	},
	hold: true,
	cull: true,
	pageSize: 20,
	columns: [
		{ Header: props => <PlusSquare style={{ cursor: 'pointer' }} onClick={() => props.parent.addChemical()} />, accessor: 'id', width: 25, 
			Cell: props => <PencilSquare style={{ cursor: 'pointer' }} onClick={() => props.parent.editChemical(props.row.values.CHEM_ID)} /> },
		{ Header: 'ID', accessor: 'CHEM_ID', width: 70,
			Cell: props => <HashLink onClick={() => props.parent.viewChemical(props.row.values.CHEM_ID)}>{props.value}</HashLink> },
		{ Header: 'Prefix', accessor: 'PREFIX', width: 100 },
		{ Header: 'Name', accessor: 'CHEM_NAME', width: 300 },
		{ Header: 'CAS', accessor: 'CAS_NUMBER', width: 125 },
		{ Header: 'Storage', accessor: 'STORAGE', includedby: 'STORAGE_NAME', width: 150 },
		{ Header: 'H Statement Code', accessor: 'H_STATEMENT_CODE', includedby: ['H_STATEMENT','H_STATEMENT_ID'] },
		{ Header: 'P Statement Code', accessor: 'P_STATEMENT_CODE', includedby: ['P_STATEMENT','P_STATEMENT_ID'] },
		{ Header: 'Signal Name', accessor: 'SIGNAL_NAME', includedby: 'SIGNAL_ID' },
		{ Header: 'ACGIH', accessor: 'AGGIH', includedby: 'AGGIH' },
		{ Header: 'EPA', accessor: 'EPA', includedby: 'EPA' },
		{ Header: 'IARC', accessor: 'IARC', includedby: 'IARC' },
		{ Header: 'NIOSH', accessor: 'NIOSH', includedby: 'NIOSH' },
		{ Header: 'NTP', accessor: 'NTP', includedby: 'NTP' },
		{ Header: 'OSHA', accessor: 'OSHA_FLAG', includedby: 'OSHA' },
		{ Header: 'Cal OSHA', accessor: 'CALOSHA_FLAG', includedby: 'CAL_OSHA' },
		{ Header: 'Prop 65 Carcinogen', accessor: 'CARCI_65', includedby: 'CARCI_65' },
		{ Header: 'Pictogram', accessor: 'PICT_DISPLAY', includedby: 'PICT_ID' },
		{ Header: 'pH Info', accessor: 'PH_INFO', includedby: 'PH_INFO' },
		{ Header: 'RTEC #', accessor: 'RTEC_NUM', includedby: 'RTECS_FLAG' },
		{ Header: 'MDL #', accessor: 'MDL_NUM', includedby: 'MDL_NUM' },
		{ Header: 'Harmonized System', accessor: 'HARMONIZED_SYS', includedby: 'HARMONIZED_SYS' },
		{ Header: 'PubChem URL', accessor: 'PUBCHEM', includedby: 'PUBCHEM' },
		{ Header: 'PubChem #', accessor: 'PUBCHEM_CID', includedby: 'PUBCHEM_CID' },
		{ Header: 'TRI', accessor: 'TRI_REPORT_THRESHOLD', includedby: ['TRI_REPORT_THRESHOLD','TRI_C'] },
		{ Header: 'TRI Compound', accessor: 'COMPOUND', includedby: ['TRI_REPORT_THRESHOLD','TRI_C'] },
		{ Header: 'Prop 65 Dev. Toxin', accessor: 'DEV_65', includedby: 'DEV_65' },
		{ Header: 'Repro M', accessor: 'REPRO_M', includedby: 'REPRO_M' },
		{ Header: 'Repro F', accessor: 'REPRO_F', includedby: 'REPRO_F' },
		{ Header: 'Acute Haz.', accessor: 'ACUTE_H_FLAG', includedby: 'ACUTE_H_FLAG' },
		{ Header: 'P Code', accessor: 'P_CODE', includedby: 'ACUTE_H_FLAG' },
		{ Header: 'Extreme Haz.', accessor: 'EXTREM_H_FLAG', includedby: 'EXTREM_H_FLAG' },
		{ Header: 'EH Approx.', accessor: 'EH_APPX', includedby: 'EXTREM_H_FLAG' },
		{ Header: 'HAP', accessor: 'HAP', includedby: 'HAP' },
		{ Header: 'CAA Urban Air', accessor: 'CAA_URBAN_AIR', includedby: 'CAA_URBAN_AIR' },
		{ Header: 'CAA 112(r) TQ', accessor: 'RMP1', includedby: 'RMP1' },
		{ Header: 'OSHA highly hazardous TQ', accessor: 'RMP2', includedby: 'RMP2' },
		{ Header: 'CalARP TQ', accessor: 'RMP3', includedby: 'RMP3' },
		{ Header: 'Non-molten TQ', accessor: 'RMP4', includedby: 'RMP4' },
		{ Header: 'TPQ §302', accessor: 'TPQ', includedby: 'TPQ' },
		{ Header: 'TPQ §302 (not molten)', accessor: 'TPQ2', includedby: 'TPQ2' },
		{ Header: 'Animal Tumor', accessor: 'ANIMAL_TUMOR', includedby: 'ANIMAL_TUMOR' },
		{ Header: 'CWC Sched.', accessor: 'CWC_SCHED', includedby: 'SCHEDULE' },
		{ Header: 'DEA #', accessor: 'DEA_NUM', includedby: 'DEA_FLAG' },
		{ Header: 'Substance Sched.', accessor: 'SUBSTANCE_SCHED', includedby: 'CONT_SUBS_FLAG' },
		{ Header: 'Fed Precursor', accessor: 'FED_PRECURSOR', includedby: 'FED_PRECURS_FLAG' },
		{ Header: 'Cal Precursor', accessor: 'CAL_PRECURSOR', includedby: 'CAL_PRECURS_FLAG' },
		{ Header: 'Bottles in Stock', accessor: 'BOTTLE_ID_LIST', includedby: ['CONT_SUBS_FLAG','FED_PRECURS_FLAG','CAL_PRECURS_FLAG'] },
		{ Header: 'Lacrimator', accessor: 'LACRIMATOR', includedby: 'LACRIMATOR' },
		{ Header: 'Skin Absorb', accessor: 'SKIN_ABSORB', includedby: 'SKIN_ABSORB' },
		{ Header: 'Vesicant', accessor: 'VESICANT', includedby: 'VESICANT' },
		{ Header: 'Unpleasant Odor', accessor: 'UNPLEASANT_ODOR', includedby: 'UNPLEASANT_ODOR' },
		{ Header: 'Stench', accessor: 'STENCH', includedby: 'STENCH' },
		{ Header: 'Rubefaciant', accessor: 'RUBEFACIANT', includedby: 'RUBEFACIANT' },
		{ Header: 'Endocrine Disruptor', accessor: 'ENDOCRINE_DIS', includedby: 'ENDOCRINE_DIS' },
		{ Header: 'Photosensitizer', accessor: 'PHOTOSENSITIZER', includedby: 'PHOTOSENSITIZER' },
		{ Header: 'Target Organs', accessor: 'ORGAN_NAME', includedby: ['ORGAN_ID','ORGAN_FLAG'] },
		{ Header: 'NFPA', accessor: 'NFPA', includedby: ['NFPA_STATEMENT_ID','NFPA_STATEMENT'] },
		{ Header: 'HMIS', accessor: 'HMIS_CODE', includedby: ['HMIS_STATEMENT_ID','HMIS_STATEMENT'] },
		{ Header: 'Intl. Standard', accessor: 'STANDARD_NAME', includedby: 'I_STANDARD' },
		{ Header: 'TRGS', accessor: 'STATEMENT_DESC', includedby: 'TRGS' },
		{ Header: 'Toxic Info', accessor: 'TOXIC_INFO', includedby: ['TOXIC_INFO','TOXIC_FLAG'] },
		{ Header: 'Usage/Misc. Info', accessor: 'USAGE_MISC_INFO', includedby: ['USAGE_MISC_INFO','USAGE_MISC_FLAG'] },
		{ Header: 'Stability/Reactivity', accessor: 'STAB_REACT', includedby: ['STAB_REACT','STABILITY_REACT_FLAG'] },
		{ Header: 'Water Reactive', accessor: 'WATER_REACTIVE', includedby: 'WATER_REACTIVE' },
		{ Header: 'Explosive Peroxides', accessor: 'EXPLOS_PEROXIDES', includedby: 'EXPLOS_PEROXIDES' },
		{ Header: 'PSN', accessor: 'PSN', includedby: 'PSN' },
		{ Header: 'Division 1', accessor: 'H_DIVISION1', includedby: 'DIVISION' },
		{ Header: 'Division 2', accessor: 'H_DIVISION2', includedby: 'DIVISION' },
		{ Header: 'Division 3', accessor: 'H_DIVISION3', includedby: 'DIVISION' },
		{ Header: 'Packing Group', accessor: 'PACKING_GROUP', includedby: 'PACKING_GROUP' },
		{ Header: 'DOT UN #', accessor: 'DOT_UN', includedby: 'DOT_UN' },
		{ Header: 'Marine Pollutant', accessor: 'MARINE_POL', includedby: 'MARINE_POL' },
		{ Header: 'Marine Pol. (severe)', accessor: 'MARINE_POL_PP', includedby: 'MARINE_POL_PP' },
		{ Header: 'DOT PIH', accessor: 'DOT_PIH', includedby: 'DOT_PIH' },
		{ Header: 'ERG Guide #', accessor: 'ERG_GUIDE', includedby: 'ERG_GUIDE' },
		{ Header: 'RQ', accessor: 'RQ', includedby: 'RQ' },
		{ Header: 'CERCLA', accessor: 'CERCLA', includedby: 'CERCLA' },
		{ Header: 'EPCRA', accessor: 'EPCRA', includedby: 'EPCRA' },
		{ Header: 'Health Haz. Cat.', accessor: 'H_CAT', includedby: ['HAZARD_ID_H','CAT_ID_H'] },
		{ Header: 'Health Hazard', accessor: 'H_HAZARD', includedby: ['HAZARD_ID_H','CAT_ID_H'] },
		{ Header: 'Health Haz. Desc.', accessor: 'H_DESC', includedby: ['HAZARD_ID_H','CAT_ID_H'] },
		{ Header: 'Health Haz. Cat. 2', accessor: 'H_CAT2', includedby: ['HAZARD_ID_H2','CAT_ID_H2'] },
		{ Header: 'Health Hazard 2', accessor: 'H_HAZARD2', includedby: ['HAZARD_ID_H2','CAT_ID_H2'] },
		{ Header: 'Health Haz. Desc. 2', accessor: 'H_DESC2', includedby: ['HAZARD_ID_H2','CAT_ID_H2'] },
		{ Header: 'Env. Haz. Cat.', accessor: 'E_CAT', includedby: ['HAZARD_ID_E','CAT_ID_E'] },
		{ Header: 'Env. Hazard', accessor: 'E_HAZARD', includedby: ['HAZARD_ID_E','CAT_ID_E'] },
		{ Header: 'Env. Haz. Desc.', accessor: 'E_DESC', includedby: ['HAZARD_ID_E','CAT_ID_E'] },
		{ Header: 'Env. Haz. Cat. 2', accessor: 'E_CAT2', includedby: ['HAZARD_ID_E2','CAT_ID_E2'] },
		{ Header: 'Env. Hazard 2', accessor: 'E_HAZARD2', includedby: ['HAZARD_ID_E2','CAT_ID_E2'] },
		{ Header: 'Env. Haz. Desc. 2', accessor: 'E_DESC2', includedby: ['HAZARD_ID_E2','CAT_ID_E2'] },
		{ Header: 'Phys. Haz. Cat.', accessor: 'P_CAT', includedby: ['HAZARD_ID_P','CAT_ID_P'] },
		{ Header: 'Phys. Hazard', accessor: 'P_HAZARD', includedby: ['HAZARD_ID_P','CAT_ID_P'] },
		{ Header: 'Phys. Haz. Desc.', accessor: 'P_DESC', includedby: ['HAZARD_ID_P','CAT_ID_P'] },
		{ Header: 'Phys. Haz. Cat. 2', accessor: 'P_CAT2', includedby: ['HAZARD_ID_P2','CAT_ID_P2'] },
		{ Header: 'Phys. Hazard 2', accessor: 'P_HAZARD2', includedby: ['HAZARD_ID_P2','CAT_ID_P2'] },
		{ Header: 'Phys. Haz. Desc. 2', accessor: 'P_DESC2', includedby: ['HAZARD_ID_P2','CAT_ID_P2'] }
	]
};

export default withSafetyDefaultRoute(Safety);
